import { FunctionComponent, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DragType } from '../../../../../Models/DragAndDrop/DragType';
import { SmoLanguage } from '../../../../../Models/Smo/SmoLanguage';
import { SmoMoon } from '../../../../../Models/Smo/SmoMoon';
import CreateMoonListActions from '../../../../../Modules/Redux/Pages/CreateMoonList/CreateMoonListActions';
import CreateMoonListSelectors from '../../../../../Modules/Redux/Pages/CreateMoonList/CreateMoonListSelectors';
import { Indexable } from '../../../../../Utils/Interfaces/Indexable';
import { Draggable } from '../../../Components/Draggable/Draggable';
import { Droppable } from '../../../Components/Droppable/Droppable';
import { Editable } from '../../../Components/Editable/Editable';
import { Grid } from '../../../Components/Grid/Grid';
import { MoonCell } from '../../../Components/MoonCell/MoonCell';

export const CreateMoonListPageMoonGrid: FunctionComponent = () => {
  const dispatch = useDispatch();
  const searchLanguage: SmoLanguage = useSelector(CreateMoonListSelectors.searchLanguage);
  const moons: SmoMoon[] = useSelector(CreateMoonListSelectors.moons);
  const moonsRef = useRef(moons);

  useEffect(() => {
    moonsRef.current = moons;
  }, [moons]);

  function indexOfMoonWithId(id: string): number {
    return moonsRef.current.findIndex((moon) => moon.id === id);
  }

  function didDrop(draggedItem: Indexable<SmoMoon>, hoverItem: Indexable<SmoMoon>): void {
    dispatch(
      CreateMoonListActions.moveMoon({
        atIndex: indexOfMoonWithId(draggedItem.item.id),
        toIndex: indexOfMoonWithId(hoverItem.item.id)
      })
    );
  }

  function didDeleteMoonWithId(moonId: string): void {
    dispatch(CreateMoonListActions.removeMoonWithId(moonId));
  }

  return (
    <Grid fillStyle="auto-fit" animating={true}>
      {moons.map((moon, index) => (
        <div key={moon.id}>
          <Editable onDelete={(): void => didDeleteMoonWithId(moon.id)}>
            <Droppable
              key={moon.id}
              type={DragType.moonCell}
              onDrop={(draggedItem: Indexable<SmoMoon>): void => didDrop(draggedItem, { item: moon, index })}
            >
              <Draggable
                type={DragType.moonCell}
                onItemRequest={(): Indexable<SmoMoon> => ({ item: moon, index: indexOfMoonWithId(moon.id) })}
              >
                <MoonCell className="h-full" moon={moon} index={index + 1} displayLanguage={searchLanguage} />
              </Draggable>
            </Droppable>
          </Editable>
        </div>
      ))}
    </Grid>
  );
};
